<template>
  <settings-modal
    hide-container
    class="t-add-countries-modal"
  >
    <div
      slot="heading"
      class="font-weight-bold"
    >{{ modalTitle }}</div>

    <error-alert :error="error" />

    <v-autocomplete
      ref="countriesInput"
      v-model="form.countryCodes"
      :error-messages="getValidationErrorMessage('countryCodes')"
      :items="countryOptions"
      :disabled="isLoading"
      item-text="name"
      item-value="value"
      multiple
      autofocus
      deletable-chips
      small-chips
      clearable
      class="t-countries-field"
    />

    <template slot="actions">
      <v-btn
        class="t-save-countries"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || isLoading"
        @click="onConfirmButtonClick"
      >save</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import form from '@/mixins/form'
  import flashMessages from '@/mixins/flashMessages'

  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CountryGroupsAddModal',
    components: { ErrorAlert, SettingsModal },
    mixins: [form, flashMessages],
    data () {
      return {
        isLoading: false,
        error: null,
        form: { countryCodes: [] }
      }
    },
    computed: {
      ...mapGetters('countries', ['countryNames']),
      ...mapGetters('modal', ['modal']),
      modalTitle () {
        return this.modal.data.title != null ? this.modal.data.title : `Add to "${this.group.name}"`
      },
      requiredFields () {
        return ['countryCodes']
      },
      group () {
        return this.modal.data.group
      },
      countryOptions () {
        return Object.entries(this.countryNames)
          .filter(([countryCode]) => !this.group.countryCodes.includes(countryCode))
          .map(([countryCode, countryName]) => {
            const formattedCode = countryCode.toUpperCase()

            return {
              name: `${countryName} (${formattedCode})`,
              value: formattedCode
            }
          })
      },
      updateCountryGroup () {
        return this.modal.data.updateCountryGroup
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onConfirmButtonClick () {
        const countries = [...this.group.countryCodes, ...this.parsedFormInput.countryCodes]

        this.setIsLoading(true)
        this.updateCountryGroup(this.group.id, countries)
          .then(() => this.showSuccessFlashMessage('Country group has been successfully updated.'))
          .catch((error) => {
            this.setIsLoading(true)
            this.setError(error)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
